import { useState } from "react"
import { Navigate, useParams } from "react-router-dom"

import { useFetchUserByIdQuery } from "../../app/adminApiSlice"
import Spinner from "../../components/Spinner"
import DisplayErrorMessage from "../../components/DisplayErrorMessage"
import ViewUserCard from "../user/components/ViewUserCard"
import UpdateUserForm from "../user/components/UpdateUserForm"
import BackButtonHeader from "../../components/buttons/BackButtonHeader"

const ViewUserPage = () => {
  const { id } = useParams()

  const [editMode, setEditMode] = useState(false)

  const { data, isSuccess, isLoading, isError, error, isFetching } = useFetchUserByIdQuery(id, { skip: !id })

  if (!id) return <Navigate to="/admin/members" />

  if (isLoading) return <Spinner />
  if (isError) {
    console.error(error || "An error occurred while fetching user data")
    return <DisplayErrorMessage>Error retrieving user data</DisplayErrorMessage>
  }
  if (!isSuccess || !data) return null

  return (
    <div
      className="w-100">
      <BackButtonHeader page={editMode ? "Edit user" : "View user"} />

      {editMode
        ? <UpdateUserForm data={data} uid={id} editMode={editMode} setEditMode={() => setEditMode(false)} isFetching={isFetching} />
        : <ViewUserCard data={data} setEditMode={() => setEditMode(true)} />
      }
    </div>
  )
}

export default ViewUserPage